import React from 'react';
import { motion } from 'framer-motion';
import { Menu, LogOut, Bell } from 'lucide-react';

interface HeaderProps {
  onLogout: () => void;
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onLogout, onMenuClick }) => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="bg-white shadow-sm border-b border-gray-100 px-4 lg:px-8 py-4"
    >
      <div className="flex items-center justify-between">
        {/* Mobile Menu Button */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <Menu className="w-6 h-6 text-gray-600" />
        </button>

        {/* Welcome Text */}
        <div className="hidden lg:block">
          <h2 className="font-poppins text-xl font-semibold text-gray-900">
            Welcome back, Admin
          </h2>
          <p className="font-inter text-sm text-gray-500">
            Here's what's happening with your dashboard today.
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center space-x-4">
          

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onLogout}
            className="flex items-center space-x-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline font-inter font-medium">Logout</span>
          </motion.button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;